
import { Chip } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';
import LinkRouter from '../../common/LinkRouter';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tag: {
      margin: '4px 4px 4px 0'
    },
    versionCol: {
      maxWidth: 250,
      width: 250,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    tagsCol: {
      width: 300
    }
  })
);

interface Props {
  versions: any[];
}

const headRows: HeadRow[] = [
  { id: 'version', disablePadding: true, label: 'Version' },
  { id: 'buildDate', disablePadding: true, label: 'Created' },
  { id: 'createdBy', disablePadding: true, label: 'Created By' },
  { id: 'tags', disablePadding: true, label: 'Tags' }
];

function FaroDeckVersionsTable(props: Props) {
  const { versions } = props;
  const classes = useStyles({});

  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('buildDate');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  };

  const sortedRows = sortRows(versions || [], getSorting(order, orderBy));

  return (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={row.version}>
              <TableCell className={classes.versionCol}>
                <LinkRouter variant="body1" to={`/faro/decks/${row.deckName}?version=${encodeURIComponent(row.version)}`}>{row.version}</LinkRouter>
              </TableCell>
              <TableCell>
                {moment(row.buildDate).fromNow()}
              </TableCell>
              <TableCell>
                {row.createdBy}
              </TableCell>
              <TableCell className={classes.tagsCol}>
                {row.tags.map(tag => <Chip key={tag} size="small" className={classes.tag} label={tag} variant="outlined" />)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={versions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default FaroDeckVersionsTable;
